"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AccountNav = require("../../AccountNav/AccountNav");

var _MenuSliderHeader = _interopRequireDefault(require("./MenuSliderHeader"));

var _MenuSliderActions = _interopRequireDefault(require("./MenuSliderActions"));

var _MenuSliderContent = _interopRequireDefault(require("./MenuSliderContent"));

var _MenuSliderFooter = _interopRequireDefault(require("./MenuSliderFooter"));

var _MenuSlider = require("./MenuSlider.style");

var MenuSlider = function MenuSlider(_ref) {
  var links = _ref.links,
      homeLink = _ref.homeLink,
      actions = _ref.actions,
      secondaryActions = _ref.secondaryActions,
      account = _ref.account,
      isNavOpen = _ref.isNavOpen,
      setIsNavOpen = _ref.setIsNavOpen,
      footerPrimaryNav = _ref.footerPrimaryNav,
      footerSecondaryNav = _ref.footerSecondaryNav,
      isLargeSlider = _ref.isLargeSlider,
      toggleNav = _ref.toggleNav,
      variation = _ref.variation,
      isSecondarySliderOpen = _ref.isSecondarySliderOpen,
      setIsSecondarySliderOpen = _ref.setIsSecondarySliderOpen,
      rest = _objectWithoutProperties(_ref, ["links", "homeLink", "actions", "secondaryActions", "account", "isNavOpen", "setIsNavOpen", "footerPrimaryNav", "footerSecondaryNav", "isLargeSlider", "toggleNav", "variation", "isSecondarySliderOpen", "setIsSecondarySliderOpen"]);

  return /*#__PURE__*/_react.default.createElement(_MenuSlider.MenuSliderWrap, {
    isNavOpen: isNavOpen,
    isSecondarySliderOpen: isSecondarySliderOpen,
    toggleNav: toggleNav,
    variation: variation
  }, /*#__PURE__*/_react.default.createElement(_MenuSliderHeader.default, {
    homeLink: homeLink,
    isNavOpen: isNavOpen,
    setIsNavOpen: setIsNavOpen,
    toggleNav: toggleNav,
    variation: variation
  }), /*#__PURE__*/_react.default.createElement(_MenuSliderActions.default, {
    actions: actions,
    account: account,
    variation: variation,
    toggleNav: toggleNav
  }), /*#__PURE__*/_react.default.createElement(_MenuSliderContent.default, Object.assign({
    links: links,
    secondaryActions: secondaryActions,
    isLargeSlider: isLargeSlider,
    toggleNav: toggleNav,
    variation: variation
  }, rest)), /*#__PURE__*/_react.default.createElement(_MenuSliderFooter.default, {
    footerPrimaryNav: footerPrimaryNav,
    footerSecondaryNav: footerSecondaryNav,
    toggleNav: toggleNav
  }));
};

MenuSlider.propTypes = {
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  secondaryActions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    startIcon: _propTypes.default.string
  })),
  account: _propTypes.default.shape(_AccountNav.accountPropTypes),
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    description: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      url: _propTypes.default.string
    }))
  })),
  homeLink: _propTypes.default.string,
  isNavOpen: _propTypes.default.bool.isRequired,
  setIsNavOpen: _propTypes.default.func.isRequired,
  footerPrimaryNav: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  footerSecondaryNav: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  isSecondarySliderOpen: _propTypes.default.bool,
  setIsSecondarySliderOpen: _propTypes.default.func,
  isLargeSlider: _propTypes.default.bool,
  toggleNav: _propTypes.default.func.isRequired,
  variation: _propTypes.default.oneOf(['mega', 'primary'])
};
MenuSlider.defaultProps = {
  actions: [],
  secondaryActions: [],
  account: null,
  links: [],
  homeLink: '/',
  footerPrimaryNav: [],
  footerSecondaryNav: [],
  isSecondarySliderOpen: false,
  setIsSecondarySliderOpen: null,
  isLargeSlider: false,
  variation: 'mega'
};
var _default = MenuSlider;
exports.default = _default;